export default {
    confirm: 'Update Settings',
    helpText:
        'How should the following fields be set when you convert to {{type}}?',
    messagesLabel: 'Messages',
    notesLabel: 'Notes',
    options: {
        copyFromPreset: 'Use Preset',
        copyFromSource: 'Copy From Original',
        leaveBlank: 'Leave Blank',
    },
    title: 'Conversion Settings - Makeleaps',
};
